export const Global = {
  set refreshData(value) {
    sessionStorage.refreshData = value;
  },
  get refreshData() {
    return sessionStorage.refreshData;
  }
};
